import Card from '@material-ui/core/Card';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import { intersection } from '../../utils/sets/Sets';
import { CardHeaderStyled, ListStyled } from './styled/Permission';
import { CustomListInterface } from './interfaces/CustomList';

export default function CustomList<T>({ propertyName, title, items, handleToggle, handleToggleAll, checked }: CustomListInterface<T>) {
    const numberOfChecked = (items: T[]) => intersection(checked, items).length;

    return (
        <Card>
            <CardHeaderStyled
                avatar={
                    <Checkbox
                        onClick={handleToggleAll(items)}
                        checked={numberOfChecked(items) === items.length && items.length !== 0}
                        indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
                        disabled={items.length === 0}
                        inputProps={{ 'aria-label': 'all items selected' }}
                    />
                }
                title={title}
                subheader={`${numberOfChecked(items)}/${items.length} selected`}
            />
            <Divider />
            <ListStyled>
                {items.map((value: any, index: number) => {
                    const labelId = `transfer-list-all-item-${value}-label`;
                    return (
                        <ListItem key={index} role="listitem" button onClick={handleToggle(value)}>
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked.some((el: any) => el[propertyName.id] === value[propertyName.id])}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': labelId }}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={value[propertyName.name]} />
                        </ListItem>
                    );
                })}
                <ListItem />
            </ListStyled>
        </Card>
    );
}